export default function toc() {
    // TOC change chevron on hover
    const tocContainer = document.querySelector("#toc_container");
    const toggleBtn = document.querySelector(".ctoc-toggle");

    if (tocContainer && toggleBtn) {
        toggleBtn.addEventListener("mouseenter", function () {
            tocContainer.classList.add("hovered");
        });

        toggleBtn.addEventListener("mouseleave", function () {
            tocContainer.classList.remove("hovered");
        });

        toggleBtn.addEventListener('click', function () {
            tocContainer.classList.toggle('active');
            const ctoc_body = document.querySelector('.ctoc-body');
            if (ctoc_body) {
                ctoc_body.slideToggle();
            }
        });
    }

    // TOC chevron for children lists
    let tocItems = document.querySelectorAll(".ctoc__item");

    if(tocItems) {
        tocItems.forEach(item => {
            let parentLi = item.closest("li");
            let nestedOl = parentLi.querySelector("ol");

            if (nestedOl) {
                nestedOl.style.display = "none";
                let chevron = document.createElement("span");
                chevron.classList.add("ctoc__item-icon");
                chevron.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                    <path d="M11 4.5L6 9.5L1 4.5" stroke="#D48300" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            `;

                parentLi.insertBefore(chevron, nestedOl);

                chevron.addEventListener("click", function (event) {
                    event.stopPropagation();

                    if (nestedOl.style.display === "none") {
                        nestedOl.style.display = "block";
                        chevron.classList.add("ctoc__item-icon--active");
                    } else {
                        nestedOl.style.display = "none";
                        chevron.classList.remove("ctoc__item-icon--active");
                    }
                });
            }
        });
    }

    let tocItemsLink = document.querySelectorAll("li > a.ctoc__item");

    if (tocItemsLink) {
        tocItemsLink.forEach((link) => {
            const span= link.nextElementSibling;
            const wrapper = document.createElement("div");
            wrapper.classList.add("ctoc__item-title");
            if (span && span.classList.contains("ctoc__item-icon")) {
                link.parentNode.insertBefore(wrapper, link);
                wrapper.appendChild(link);
                wrapper.appendChild(span);
            } else {
                link.parentNode.insertBefore(wrapper, link);
                wrapper.appendChild(link);
            }
        });
    }
}